import { Helmet } from 'react-helmet-async';
import EmentaEditView from 'src/sections/ementas/view/ementas-edit-view';

export default function EmentasEditPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Ementas</title>
      </Helmet>

      <EmentaEditView />
    </>
  );
}
